export function isNumber(anyObj){
  return typeof anyObj==="number";
}
export function extractNumber(str){
  const numReg = /^\d+$/g;
  if (numReg.test(str)){
    return Number(str);
  }
  return 0;
}


// WEBPACK FOOTER //
// ./src/util/numberhelpers.js